import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainPoints } from './components/sections/PainPoints';
import { Tomos } from './components/sections/Tomos';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { EliteProtocol } from './components/sections/EliteProtocol';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { CostOfInaction } from './components/sections/CostOfInaction';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { PurchaseNotifier } from './components/PurchaseNotifier';
export function App() {
  return <div className="w-full bg-ink text-ice" data-id="element-0" data-mp="2wip5x1c7ng4e">
      <Hero data-id="element-1" data-mp="28u5uwe1s0p8m" />
      <main data-id="element-2" data-mp="28tmg367fagyt">
        <PainPoints data-id="element-3" data-mp="28te4dhn1dhp7" />
        <Tomos data-id="element-4" data-mp="28sl3gxardmez" />
        <Bonuses data-id="element-5" data-mp="28sbe9bxjfjac" />
        <Pricing data-id="element-6" data-mp="23vcmh01cjofb" />
        <EliteProtocol data-id="element-7" data-mp="23vulg4fe8gqx" />
        <Guarantee data-id="element-8" data-mp="23ujlygszdv5m" />
        <Faq data-id="element-9" data-mp="23v2td3l0915e" />
        <CostOfInaction data-id="element-10" data-mp="23ti7s3go4sjo" />
        <FinalCTA data-id="element-11" data-mp="3ikh8gaq64uzi" />
      </main>
      <Footer data-id="element-12" data-mp="3ij63w8owfj7c" />
      <PurchaseNotifier data-id="element-13" data-mp="3ijpbowku4r7n" />
    </div>;
}